import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MadAuthService } from "src/app/core/mad-auth/mad-auth.service";
import { SubdomainService } from "src/app/core/_base/subdomain.service";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class CommunitiesService {
  constructor(
    private http: HttpClient,
    private authService: MadAuthService,
    private subdomainService: SubdomainService
  ) { }

  fetch() {
    return this.http.get<{ data: { id: number, name: string }[] }>(
      environment.baseApiUrl + `api/v2/${this.subdomainService.subDomain}/communities`,
      {
        headers: this.authService.getAuthHeaders()
      }
    )
  }
}